import React, { Component } from 'react';
import { Loading } from 'elements';
class Tree extends Component {
    constructor() {
        super(...arguments);
        this.renderLeaf = (item, index) => {
            const { level, subTreeExtractor, keyExtractor, renderItem, onSelectItem } = this.props;
            const handleSelectItem = onSelectItem || (() => { });
            const subTree = subTreeExtractor(item, index) || [];
            const leaf = (React.createElement("div", { key: keyExtractor(item, index), onClick: () => handleSelectItem(item) }, renderItem(item, level)));
            if (subTree.length === 0)
                return leaf;
            return (React.createElement("div", { key: keyExtractor(item, index) },
                leaf,
                React.createElement(Tree, Object.assign({}, this.props, { data: subTree, level: level + 1 }))));
        };
    }
    render() {
        const { data, loading } = this.props;
        if (loading)
            return React.createElement(Loading, null);
        return React.createElement("div", null, data.map((item, index) => this.renderLeaf(item, index)));
    }
}
Tree.defaultProps = {
    level: 0
};
export default Tree;



//////////////////
// WEBPACK FOOTER
// ./src/components/Tree.tsx
// module id = 553
// module chunks = 0